<template>
  <b-container fluid class="main-container">
    <PlansHeader />
    <PurchaseFlow :show-plans="true" :plans-new-page="true" :plans-page="plansPage" />
    <b-container>
      <Video
        id="plans-video-container"
        :options="playerOptions"
        :classes="'video-player-box overflow-hidden rounded w-100 mt-5 mb-5'"
      />
    </b-container>
    <TrustedBy v-if="isDesignActive" />
    <LicensesBlock v-else />
    <PlansCompare />
    <Faq />
    <GetGraphics />
    <IconBlock />
    <Testimonials :title="$t(`plans.${getExperience}.tags.testimonialsTitle`)" />
    <SubscribeBanner />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Video from '@/components/Common/Video.vue';
import PlansHeader from 'Plans/Header';
import SubscribeBanner from 'Plans/SubscribeBanner';
import Faq from '@/components/Common/Faq';
import LicensesBlock from 'Plans/LicensesBlock';
import TrustedBy from '@/components/Common/TrustedBy';
import PlansCompare from 'Plans/PlansCompare';
import GetGraphics from 'Plans/GetGraphics';
import IconBlock from 'Plans/IconBlock';
import PurchaseFlow from '@/components/PurchaseFlow';
import Testimonials from '@/components/Common/Testimonials';

export default {
  components: {
    PlansHeader,
    Video,
    SubscribeBanner,
    LicensesBlock,
    TrustedBy,
    Faq,
    PlansCompare,
    Testimonials,
    GetGraphics,
    IconBlock,
    PurchaseFlow
  },
  props: {
    plansPage: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      playerOptions: {
        language: 'en',
        playbackRates: [1.0],
        sources: [
          {
            type: 'video/mp4',
            src: 'https://images.vexels.com/files/web/assets/meet-vexels.mp4'
          }
        ],
        poster: 'https://cdn.vexels.com/img/preview-video-vexels.jpg'
      }
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperience', 'isDesignActive'])
  },
  mounted() {
    const hash = this.$route.hash;
    const el = hash && document.querySelector(hash);
    el && el.scrollIntoView();
  }
};
</script>

<style scoped>
.main-container {
  padding: 0;
}
</style>
